import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const StratagemContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StratagemProvider = ({ children }) => {
  const [stratagems, setStratagems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchStratagems = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(`${API}/stratagems`);
      const items = response.data || [];
      const unique = Array.from(new Map(items.map((item) => [item.id, item])).values());
      setStratagems(unique);
    } catch {
      setError("Unable to sync stratagem catalog. Try again later.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStratagems();
  }, [fetchStratagems]);

  return (
    <StratagemContext.Provider value={{ stratagems, loading, error, refresh: fetchStratagems }}>
      {children}
    </StratagemContext.Provider>
  );
};

export const useStratagems = () => {
  const context = useContext(StratagemContext);
  if (!context) {
    throw new Error("useStratagems must be used within a StratagemProvider");
  }
  return context;
};
